window.addEventListener( 'load', function() {

	jQuery(document).on('click', '.features-benefits__toggle', function() {
		console.log( jQuery(this) );

		// jQuery(this).toggleClass('active');

		if ( jQuery(this).hasClass('active') ) {
			jQuery(this).removeClass('active');
		} else {
			jQuery(this).addClass('active');
		}

		var wrapper = jQuery(this).next('.features-benefits__container');
		var list = wrapper.children('ul');
		var listHeight = list.height();
		
		if ( jQuery(this).hasClass('active') ) {
			wrapper.height( listHeight + 'px' );
		} else {
			wrapper.height( '0px' );
		}
	});
});
